export const movies = [
  {
    id: 'movie-01',
    title: '铃芽之旅',
    originalTitle: 'すずめの戸締まり',
    type: 'movie',
    region: 'jp',
    year: 2022,
    genre: '动画 / 奇幻 / 冒险',
    subtitleStatus: 'completed',
    tags: ['新海诚', '动画电影', '奇幻冒险', '治愈'],
    updatedAt: '2026-09-18',
    popularity: 9860,
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20artwork%20for%20an%20animated%20Japanese%20fantasy%20journey%20film%2C%20a%20lone%20girl%20silhouette%20facing%20a%20vast%20glowing%20sky%2C%20blurred%20teal%20and%20amber%20tones%2C%20atmospheric%20volumetric%20light%2C%20abstract%20graphic%20overlays%2C%20no%20text%2C%20elegant%20minimal%20editorial%20composition%2C%20high%20detail%2C%20premium%20film%20aesthetic&width=600&height=900&seq=poster-movie-01&orientation=portrait',
    description: '少女铃芽踏上关闭灾难之门的旅程，穿越日本各地，用勇气与温柔治愈彼此的伤痕。',
    synopsis: '生活在九州小镇的少女岩户铃芽，偶然遇见为关闭灾难之门而旅行的青年草太，从此被卷入一场横跨日本列岛的奇幻旅程。她必须寻找并封印引发地震的“蚯蚓”，在旅途中重新理解生死与告别。',
    subtitleNote: '该片由知名翻译组完成公映版简繁双语字幕，时间轴与 Blu-ray 片源完全对齐，润色版已同步更新。',
    subtitleVersions: [
      { id: 'movie-01-v1', language: '简体中文', team: '风森字幕组', format: 'ASS', publishedAt: '2026-09-18', note: '公映版精校' },
      { id: 'movie-01-v2', language: '繁体中文', team: '青空字幕', format: 'SRT', publishedAt: '2026-07-02', note: '蓝光对齐' },
      { id: 'movie-01-v3', language: '中日双语', team: '风森字幕组', format: 'ASS', publishedAt: '2026-06-20', note: '含特效歌词' },
    ],
  },
  {
    id: 'movie-02',
    title: '你想活出怎样的人生',
    originalTitle: '君たちはどう生きるか',
    type: 'movie',
    region: 'jp',
    year: 2023,
    genre: '动画 / 奇幻 / 剧情',
    subtitleStatus: 'completed',
    tags: ['宫崎骏', '吉卜力', '动画电影', '成长'],
    updatedAt: '2026-09-12',
    popularity: 9410,
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20artwork%20for%20a%20hand%20drawn%20Japanese%20animated%20fantasy%20about%20growing%20up%2C%20a%20boy%20standing%20before%20an%20ancient%20tower%20and%20floating%20islands%2C%20deep%20indigo%20and%20warm%20ochre%20palette%2C%20dreamlike%20atmosphere%2C%20abstract%20graphic%20overlays%2C%20no%20text%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20premium%20film%20aesthetic&width=600&height=900&seq=poster-movie-02&orientation=portrait',
    description: '少年真人走入神秘塔楼，穿越生与死的世界，在异境中寻找关于成长与母亲的答案。',
    synopsis: '二战时期的少年牧真人随父亲搬至乡间，被一座废弃塔楼与一只会说话的苍鹭引入奇幻世界。在那里他遇见火之少女与神秘的叔父，逐渐理解生活、失去与自我选择的意义。',
    subtitleNote: '本作品字幕由多个翻译组协作完成，配音版与字幕版均有对应时间轴，另附宫崎骏访谈短片字幕。',
    subtitleVersions: [
      { id: 'movie-02-v1', language: '简体中文', team: '萤火翻译社', format: 'SRT', publishedAt: '2026-09-12' },
      { id: 'movie-02-v2', language: '繁体中文', team: '晨光字幕', format: 'SRT', publishedAt: '2026-08-01' },
    ],
  },
  {
    id: 'movie-03',
    title: '怪物',
    originalTitle: '怪物',
    type: 'movie',
    region: 'jp',
    year: 2023,
    genre: '剧情 / 悬疑',
    subtitleStatus: 'completed',
    tags: ['是枝裕和', '剧情', '悬疑', '社会'],
    updatedAt: '2026-09-05',
    popularity: 8720,
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20artwork%20for%20a%20melancholic%20Japanese%20social%20drama%20film%2C%20two%20children%20silhouettes%20by%20a%20rainy%20lake%20at%20dusk%2C%20muted%20grey%20and%20soft%20amber%20tones%2C%20atmospheric%20mist%2C%20abstract%20graphic%20overlays%2C%20no%20text%2C%20elegant%20minimal%20editorial%20composition%2C%20high%20detail%2C%20premium%20film%20aesthetic&width=600&height=900&seq=poster-movie-03&orientation=portrait',
    description: '一场校园冲突牵扯出母亲、老师与孩子三个视角，真相在层层叙述中不断翻转。',
    synopsis: '单亲母亲早织发现儿子麦野奏的行为越来越反常，她质问学校，却被老师保利敷衍。随着多重视角的展开，被掩埋的事件全貌逐渐浮现，谁才是真正的“怪物”，答案出乎意料。',
    subtitleNote: '字幕组针对多段方言与儿童语气的台词做了细致注解，附带重要情节的时间码索引。',
    subtitleVersions: [
      { id: 'movie-03-v1', language: '简体中文', team: '子夜字幕组', format: 'ASS', publishedAt: '2026-09-05', note: '含方言注释' },
      { id: 'movie-03-v2', language: '繁体中文', team: '子夜字幕组', format: 'ASS', publishedAt: '2026-08-11' },
    ],
  },
  {
    id: 'movie-04',
    title: '驾驶我的车',
    originalTitle: 'ドライブ・マイ・カー',
    type: 'movie',
    region: 'jp',
    year: 2021,
    genre: '剧情 / 文艺',
    subtitleStatus: 'completed',
    tags: ['村上春树', '文艺片', '表演', '戛纳'],
    updatedAt: '2026-08-28',
    popularity: 7980,
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20artwork%20for%20an%20introspective%20Japanese%20literary%20drama%20film%2C%20a%20red%20car%20driving%20along%20a%20coastal%20road%20at%20twilight%2C%20deep%20teal%20shadow%20with%20warm%20amber%20highlights%2C%20long%20exposure%20motion%20blur%2C%20abstract%20graphic%20overlays%2C%20no%20text%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20premium%20film%20aesthetic&width=600&height=900&seq=poster-movie-04&orientation=portrait',
    description: '舞台剧导演与沉默的女司机在旅途中逐渐敞开心扉，面对爱、失去与自我和解。',
    synopsis: '舞台剧演员兼导演家福悠介在妻子去世后独自生活，受邀前往广岛排演《万尼亚舅舅》。由年轻女司机渡部美咲负责接送，两人在一次次车程中交换沉默，也交换彼此未曾言说的伤痛。',
    subtitleNote: '本作品字幕包含大量戏剧台词与多语种对白，制作组提供了台词速览与文学背景参考注释。',
    subtitleVersions: [
      { id: 'movie-04-v1', language: '简体中文', team: '长镜头字幕组', format: 'ASS', publishedAt: '2026-08-28', note: '含戏剧注释' },
      { id: 'movie-04-v2', language: '中日双语', team: '长镜头字幕组', format: 'ASS', publishedAt: '2026-07-19' },
    ],
  },
  {
    id: 'movie-05',
    title: '寄生虫',
    originalTitle: '기생충',
    type: 'movie',
    region: 'kr',
    year: 2019,
    genre: '剧情 / 悬疑 / 黑色幽默',
    subtitleStatus: 'completed',
    tags: ['奉俊昊', '黑色幽默', '社会寓言', '奥斯卡'],
    updatedAt: '2026-08-22',
    popularity: 10240,
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20artwork%20for%20a%20Korean%20black%20comedy%20social%20thriller%20film%2C%20a%20modern%20glass%20house%20on%20a%20hill%20with%20four%20figures%20climbing%20upward%2C%20muted%20emerald%20and%20warm%20amber%20tones%2C%20dramatic%20shadow%2C%20abstract%20graphic%20overlays%2C%20no%20text%2C%20elegant%20minimal%20editorial%20composition%2C%20high%20detail%2C%20premium%20film%20aesthetic&width=600&height=900&seq=poster-movie-05&orientation=portrait',
    description: '底层一家人渗入上流家庭，阶级的裂缝在暴雨之夜彻底崩塌。',
    synopsis: '住在半地下室的基宇一家生活拮据，他凭借伪造学历成为富人朴社长家的家教，随后把全家人都安插进豪宅。两个阶层看似和谐的共处，最终被一场突如其来的暴雨撕开真相。',
    subtitleNote: '字幕组对片中韩式幽默与阶级隐喻做了双版本翻译，附送导演解读与关键台词对照表。',
    subtitleVersions: [
      { id: 'movie-05-v1', language: '简体中文', team: '半岛字幕组', format: 'ASS', publishedAt: '2026-08-22' },
      { id: 'movie-05-v2', language: '繁体中文', team: '半岛字幕组', format: 'SRT', publishedAt: '2026-06-30' },
      { id: 'movie-05-v3', language: '中韩双语', team: '光影字幕', format: 'ASS', publishedAt: '2026-05-14' },
    ],
  },
  {
    id: 'movie-06',
    title: '分手的决心',
    originalTitle: '헤어질 결심',
    type: 'movie',
    region: 'kr',
    year: 2022,
    genre: '爱情 / 悬疑',
    subtitleStatus: 'completed',
    tags: ['朴赞郁', '悬疑爱情', '戛纳', '氛围'],
    updatedAt: '2026-08-15',
    popularity: 8540,
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20artwork%20for%20a%20Korean%20romantic%20mystery%20film%2C%20a%20woman%20seen%20through%20fogged%20sea%20mist%20with%20a%20detective%20silhouette%20behind%2C%20deep%20ocean%20blue%20and%20soft%20copper%20tones%2C%20moody%20atmosphere%2C%20abstract%20graphic%20overlays%2C%20no%20text%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20premium%20film%20aesthetic&width=600&height=900&seq=poster-movie-06&orientation=portrait',
    description: '刑警调查一桩坠崖案，却对死者之妻渐生情愫，理性与情感在海雾中相互纠缠。',
    synopsis: '刑警海俊接手调查登山者的离奇死亡，遇见了死者的中国籍妻子瑞莱。随着调查深入，怀疑与吸引同时滋长，两人在克制与试探中靠近，又不得不面对这场关系终将迎来的结局。',
    subtitleNote: '作品含中韩双语对白，字幕组特别区分了两种语言的语气差异，并提供台词逐句对照。',
    subtitleVersions: [
      { id: 'movie-06-v1', language: '简体中文', team: '潮汐字幕组', format: 'ASS', publishedAt: '2026-08-15', note: '含中韩对照' },
      { id: 'movie-06-v2', language: '繁体中文', team: '潮汐字幕组', format: 'ASS', publishedAt: '2026-07-08' },
    ],
  },
  {
    id: 'movie-07',
    title: '非常宣言',
    originalTitle: '비상선언',
    type: 'movie',
    region: 'kr',
    year: 2022,
    genre: '灾难 / 剧情 / 悬疑',
    subtitleStatus: 'in-progress',
    tags: ['灾难片', '航空', '群像', '紧张'],
    updatedAt: '2026-10-02',
    popularity: 7320,
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20artwork%20for%20a%20Korean%20aviation%20disaster%20thriller%20film%2C%20a%20lone%20passenger%20plane%20against%20a%20stormy%20sky%20with%20amber%20emergency%20lights%2C%20desaturated%20steel%20blue%20and%20warm%20orange%20tones%2C%20tense%20atmosphere%2C%20abstract%20graphic%20overlays%2C%20no%20text%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20premium%20film%20aesthetic&width=600&height=900&seq=poster-movie-07&orientation=portrait',
    description: '一架客机遭遇生化危机，机长、乘客与地面人员在万米高空展开生死博弈。',
    synopsis: '一架飞往夏威夷的客机在途中被乘客散播的病毒威胁，资深机长具仁浩与乘务员们必须维持秩序。与此同时，地面危机应对组也在争分夺秒地寻找解决方案，一场关于责任与人性的考验就此展开。',
    subtitleNote: '制作组正在同步校对航空专业术语与紧急广播台词，简繁版本预计近期完成并发布。',
    subtitleVersions: [
      { id: 'movie-07-v1', language: '简体中文', team: '云梯字幕组', format: 'SRT', publishedAt: '2026-10-02', note: '校对中' },
    ],
  },
  {
    id: 'movie-08',
    title: '魔法少女小圆剧场版',
    originalTitle: '劇場版 魔法少女まどか☆マギカ',
    type: 'movie',
    region: 'jp',
    year: 2024,
    genre: '动画 / 奇幻 / 剧情',
    subtitleStatus: 'completed',
    tags: ['动画电影', '奇幻', '反转', '系列作'],
    updatedAt: '2026-07-30',
    popularity: 7680,
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20artwork%20for%20a%20Japanese%20magical%20girl%20animated%20fantasy%20film%2C%20a%20girl%20silhouette%20against%20a%20shattered%20starry%20sky%20of%20purple%20grey%20and%20amber%20sparks%2C%20dramatic%20swirls%20of%20light%2C%20abstract%20graphic%20overlays%2C%20no%20text%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20premium%20film%20aesthetic&width=600&height=900&seq=poster-movie-08&orientation=portrait',
    description: '在希望与绝望的循环之上，少女们为改写命运再次许下愿望。',
    synopsis: '延续系列的世界观，故事发生在被重重谜团包裹的都市之中。魔法少女们各自怀揣不同的愿望与代价，当旧日的选择重新浮现，她们必须决定要为谁的未来而战。',
    subtitleNote: '字幕组完整还原了作品特有的符号化演出说明，并附世界观设定名词表供参考。',
    subtitleVersions: [
      { id: 'movie-08-v1', language: '简体中文', team: '星光字幕组', format: 'ASS', publishedAt: '2026-07-30', note: '含名词表' },
      { id: 'movie-08-v2', language: '繁体中文', team: '星光字幕组', format: 'ASS', publishedAt: '2026-06-12' },
    ],
  },
  {
    id: 'movie-09',
    title: '掮客',
    originalTitle: '브로커',
    type: 'movie',
    region: 'kr',
    year: 2022,
    genre: '剧情 / 家庭',
    subtitleStatus: 'completed',
    tags: ['是枝裕和', '温情', '公路片', '群像'],
    updatedAt: '2026-07-22',
    popularity: 6980,
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20artwork%20for%20a%20warm%20Korean%20road%20trip%20drama%20film%2C%20a%20small%20van%20on%20a%20rainy%20countryside%20road%20with%20soft%20lamplight%2C%20gentle%20sage%20green%20and%20muted%20amber%20tones%2C%20tender%20atmosphere%2C%20abstract%20graphic%20overlays%2C%20no%20text%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20premium%20film%20aesthetic&width=600&height=900&seq=poster-movie-09&orientation=portrait',
    description: '两个掮客带着弃婴踏上寻亲之旅，一路同行的陌生人组成了意外的“一家人”。',
    synopsis: '在雨季的釜山，弃婴保护箱旁的白发男子与同伴带走了婴儿，打算为其寻找合适的家庭。可与他们同行的还有追查此事的刑警与独自上路的少年，一段充满偶然与温情的旅程就此展开。',
    subtitleNote: '字幕组为雨天场景中的环境音与旁白补充了描述性注释，便于听力辅助用户理解。',
    subtitleVersions: [
      { id: 'movie-09-v1', language: '简体中文', team: '青禾字幕组', format: 'SRT', publishedAt: '2026-07-22' },
      { id: 'movie-09-v2', language: '中韩双语', team: '青禾字幕组', format: 'ASS', publishedAt: '2026-06-05' },
    ],
  },
  {
    id: 'movie-10',
    title: '灌篮高手 THE FIRST',
    originalTitle: 'THE FIRST SLAM DUNK',
    type: 'movie',
    region: 'jp',
    year: 2022,
    genre: '动画 / 运动 / 热血',
    subtitleStatus: 'completed',
    tags: ['热血', '篮球', '青春', '经典'],
    updatedAt: '2026-07-15',
    popularity: 8120,
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20artwork%20for%20a%20Japanese%20high%20school%20basketball%20sports%20anime%20film%2C%20a%20player%20mid%20jump%20shot%20silhouette%20under%20arena%20spotlights%2C%20crimson%20and%20deep%20teal%20with%20warm%20amber%20flashes%2C%20dynamic%20motion%20energy%2C%20abstract%20graphic%20overlays%2C%20no%20text%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20premium%20film%20aesthetic&width=600&height=900&seq=poster-movie-10&orientation=portrait',
    description: '湘北高中再战全国大赛，汗水与呐喊之中，青春的热血在球场上燃烧。',
    synopsis: '以宫城良田的视角重新讲述湘北篮球队征战全国大赛的故事。面对实力强劲的山王工业，队员们在绝境中彼此信任，用一次次传球与投篮追平比分，谱写属于青春的逆转。',
    subtitleNote: '字幕组对球场战术术语做了通俗化处理，并附赠经典台词与名场面对照清单。',
    subtitleVersions: [
      { id: 'movie-10-v1', language: '简体中文', team: '热血字幕组', format: 'ASS', publishedAt: '2026-07-15', note: '含术语解释' },
      { id: 'movie-10-v2', language: '繁体中文', team: '热血字幕组', format: 'SRT', publishedAt: '2026-05-28' },
    ],
  },
  {
    id: 'movie-11',
    title: '咒术回战 0',
    originalTitle: '呪術廻戦 0',
    type: 'movie',
    region: 'jp',
    year: 2021,
    genre: '动画 / 奇幻 / 动作',
    subtitleStatus: 'completed',
    tags: ['动画电影', '动作', '系列', '热血'],
    updatedAt: '2026-07-06',
    popularity: 7460,
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20artwork%20for%20a%20Japanese%20dark%20fantasy%20action%20anime%20film%2C%20a%20lone%20student%20with%20cursed%20energy%20swirls%20around%20him%20in%20a%20neon%20lit%20city%20night%2C%20deep%20indigo%20and%20amber%20sparks%2C%20dramatic%20contrast%2C%20abstract%20graphic%20overlays%2C%20no%20text%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20premium%20film%20aesthetic&width=600&height=900&seq=poster-movie-11&orientation=portrait',
    description: '少年乙骨忧太背负诅咒之力进入咒术高专，为守护同伴与命运正面对抗。',
    synopsis: '因青梅竹马里香的怨灵附身，乙骨忧太被卷入咒术世界，进入东京咒术高专学习。他必须在守护里香与控制诅咒之间做出抉择，并在与夏油杰的对决中重新定义自己的力量。',
    subtitleNote: '制作组提供了咒术专有名词与术式名称的统一译名表，保证系列作品译名延续一致。',
    subtitleVersions: [
      { id: 'movie-11-v1', language: '简体中文', team: '咒术字幕组', format: 'ASS', publishedAt: '2026-07-06' },
      { id: 'movie-11-v2', language: '中日双语', team: '咒术字幕组', format: 'ASS', publishedAt: '2026-05-20' },
    ],
  },
  {
    id: 'movie-12',
    title: '下一个素熙',
    originalTitle: '다음 소희',
    type: 'movie',
    region: 'kr',
    year: 2022,
    genre: '剧情 / 社会',
    subtitleStatus: 'in-progress',
    tags: ['社会现实', '职场', '剧情', '反思'],
    updatedAt: '2026-10-05',
    popularity: 6420,
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20artwork%20for%20a%20gritty%20Korean%20social%20realist%20drama%20film%2C%20a%20young%20woman%20silhouette%20at%20a%20cold%20fluorescent%20call%20center%20desk%2C%20cold%20steel%20blue%20with%20a%20faint%20amber%20glow%2C%20stark%20atmosphere%2C%20abstract%20graphic%20overlays%2C%20no%20text%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20premium%20film%20aesthetic&width=600&height=900&seq=poster-movie-12&orientation=portrait',
    description: '刑警调查一名实习生之死，牵扯出职校与企业之间层层推诿的现实困境。',
    synopsis: '女刑警宥真接手一桩女高中生溺亡的案件，顺着线索走进她曾实习的呼叫中心。镜头在调查者与当事人的视角之间切换，逐步揭开一个被就业压力与制度冷漠层层包裹的现实。',
    subtitleNote: '字幕组正在校对大量职场与法律相关用语，计划同步发布简繁与双语三版本。',
    subtitleVersions: [
      { id: 'movie-12-v1', language: '简体中文', team: '纪实字幕组', format: 'SRT', publishedAt: '2026-10-05', note: '校对中' },
    ],
  },
];